import classNames from 'classnames';
import {Icon} from '@iconify/react';
import {User} from '../User/User';
import * as React from 'react';
import {FC, useState} from 'react';
import {createUserInstance} from '../../Users';
import {IMenuOption} from '../Menu/Menu';
import {IUser} from '../../Constants/Interfaces';
import {useDispatch} from 'react-redux';
import {Dispatch} from '../../Redux/store';


interface IAddressListProps {
    addresses: string[];
    selectedId: string;
    users: IUser[];
}


export const AddressList: FC<IAddressListProps> = (props) => {

    const dispatch = useDispatch<Dispatch>();

    const [inputValue, setInputValue] = useState<string>('');
    const [collapsed, setCollapsed] = useState<boolean>(false);


    function onChange(e: any): void {
        setInputValue(e.target.value);
    }


    function handleAddressInputBlur(
        e?: React.FocusEvent<HTMLInputElement>,
    ) {
        const formattedAddress = inputValue.trim().toLowerCase();

        //Validate address
        if (/^(0x)?[0-9a-f]{40}$/.test(formattedAddress)) {
            addAddress(formattedAddress);
        }
        setInputValue('');
    }


    function catchEnterButton(
        e: React.KeyboardEvent<HTMLInputElement>,
    ) {
        if (e.key === 'Enter') {
            handleAddressInputBlur();
        }
    }


    function addAddress(address: string): void {
        dispatch.users.addAddress(address);
    }


    function deleteAddress(address: string) {
        dispatch.users.updateAddresses(props.addresses.filter((i) => i !== address));
    }


    function getAddressMenuOptions(address: string): IMenuOption[] {
        return [
            {
                text: 'Message',
                icon: 'wpf:message',
                callback: () => dispatch.main.update({selectedId: address, viewProfile: false}),
                highlight: false,
            },
            {
                text: 'Delete',
                icon: 'fluent:delete-20-filled',
                callback: () => deleteAddress(address),
                highlight: true,
            },
        ];
    }


    async function paste() {
        const value = await navigator.clipboard.readText();
        if (value) {
            setInputValue(value);
        }
    }


    return (
        <div className={classNames('mvc-list', {collapsed})}>
            <div className={'mvc-list-header'}>
                <Icon
                    icon={'fluent:copy-20-regular'}
                    onClick={paste}
                    height={16}
                    className={'mvc-list-header-left-icon'}/>

                <input
                    className={'mvc-list-header-input'}
                    placeholder={'Paste address'}
                    value={inputValue}
                    onBlur={handleAddressInputBlur}
                    onKeyDown={catchEnterButton}
                    onChange={onChange}/>

                <Icon
                    icon={'eva:arrow-ios-downward-fill'}
                    height={16}
                    onClick={() => setCollapsed(!collapsed)}
                    className={'mvc-list-header-right-icon'}/>
            </div>
            {props.addresses
                  .map((uid, i) => {

                      const user = props.users.find((user) => user.uid === uid) || createUserInstance({uid});
                      const menuOptions: IMenuOption[] = getAddressMenuOptions(uid);

                      const selected = props.selectedId === user.uid;

                      return <User
                          key={i}
                          selected={selected}
                          // expandable={false}
                          menu={menuOptions}
                          avatar_url={user.avatar.face}
                          online={user.online}
                          name={user.name}
                          status_text={user.online ? 'online' : 'offline'}
                          name_suffix={user.uid.slice(user.uid.length - 4, user.uid.length)}/>;
                  })}
        </div>
    );
};